import { getMetafield } from 'src/functions/util/getMetafield'

import type { Collection } from 'src/data/graphql-generated'
import type { Locale } from 'src/enum/Locale'

interface FilterType {
  title: string
  identifier: string
}

export const getFilters = (collection: Collection, locale: Locale): string[] => {
  const filterTypes: FilterType[] = getMetafield(collection.metafields, 'layout', 'filters', locale) || []

  if (!filterTypes.length) {
    return []
  }

  const [filterType] = filterTypes

  const options = collection.products.nodes
    .map((product) => getMetafield(product.metafields, 'filter', filterType.identifier, locale))
    .flat()
    .map((filter) => filter?.title)
    .filter((title) => !!title)

  return Array.from(new Set(options)) as string[]
}

export const getFilteredProducts = (collection: Collection, filter: string, locale: Locale) => {
  if (!filter) {
    return collection.products.nodes
  }

  const filterTypes: FilterType[] = getMetafield(collection.metafields, 'layout', 'filters', locale) || []
  const [filterType] = filterTypes

  return collection.products.nodes.filter((product) => {
    const productFilters: Array<{ title: string } | null> =
      getMetafield(product.metafields, 'filter', filterType.identifier, locale) || []

    return productFilters.some((f) => f?.title === filter)
  })
}
